"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInjectReducer = useInjectReducer;
exports.useInjectSaga = useInjectSaga;
const redux_injectors_1 = require("redux-injectors");
/* Wrap redux-injectors with stricter types */
function useInjectReducer(params) {
    return (0, redux_injectors_1.useInjectReducer)(params);
}
function useInjectSaga(params) {
    return (0, redux_injectors_1.useInjectSaga)(params);
}
//# sourceMappingURL=redux-injectors.js.map